export const ROUTE_PATHS = {
  OAUTH: "/oauth/*",
  LOGIN: "/oauth/login",
  LOGOUT: "/oauth/logout",
  CALLBACK: "/oauth/callback",
  ONBOARDING: "/onboarding",
  ONBOARDING_CONNECT: "/onboarding/connect",
  ONBOARDING_STEP_2: "/onboarding/step-2",
  ONBOARDING_IMPORT: "/onboarding/import",
  ONBOARDING_SUCCESS: "/onboarding/success",
  ONBOARDING_SHOPIFY_CALLBACK: "/onboarding/shopify-callback",
  HOME: "/",
  ADMIN_ROASTERS: "/admin/roasters",
  DASHBOARD: "/dashboard",
  PRODUCTS: "/products",
  ORDERS: "/orders",
  ORDERS_WAITING_SUMMARY: "/orders/waiting-summary",
  ANALYTICS: "/analytics",
  CUSTOMERS: "/customers",
  INVENTORY: "/inventory",
  LABELS: "/labels",
  NOTIFICATIONS: "/notifications",
  PREFERENCES: "/preferences",
  FINANCE: "/finance",
  FINANCE_INVOICES: "/finance/invoices",
  FINANCE_SETTINGS: "/finance/settings",
  BATCHES: "/batches",
  BATCH_SUMMARY: "/batches/:batchId/summary",
  MARKETPLACE: "/marketplace",
  ALERTS: "/alerts",
  CONTACT_US: "/contact-us",
  ADMIN_CROSS_BORDER: "/admin/cross-border",
};
